export const PER_PAGE = 20;
export const DocumentError2 = "Invalid file type.";
export const DocumentError3 = "Total file size exceeds 75 MB.";
export const DocumentError4 = "Document already selected, do not select duplicate document.";
export const DocumentError5 = "file size should not be 0.";
export const DocumentError6 = "Delete the existing file before uploading a new file.";
export const DocumentError7 = "Do not select more than 1 file.";
export const BCBSMIMINSOCDATE = "3/1/2026";
export const AETNA_MIN_SOC_DATE = "9/1/2026";
export const BCBSMI = "BCBS MICHIGAN";
export const AETNA = "AETNA";
